<template>
  <DefaultModal @close="$emit('close')">
    <template #header>
      <DefaultModalTitle>
        <template
          v-if="
            !selectedDocumentCategoryTypes?.length &&
            !['CURRENT_TENANT', 'SECONDARY_TENANT'].includes(currentModal)
          "
          >Filer</template
        >
        <template v-else
          >Filer / {{ selectedName || currentModalName }}</template
        >
      </DefaultModalTitle>
    </template>

    <template #body>
      <GeneratePdfModal
        v-if="generatePdfVisible && !!documentsCollections"
        :application-id="applicationId"
        :documents-collections="documentsCollections"
        :landlord-files="filesFromId"
        :has-scrive-document="hasScriveDocument"
        :is-ah-or-ov="true"
        @close="generatePdfVisible = false"
      />
      <AdditionalFilesModal
        v-if="additionalFilesModalVisible"
        :application-id="applicationId"
        @close="additionalFilesModalVisible = false"
      />
      <FilePreviewModal
        v-if="showFilePreviewModal"
        :title="current.title"
        :mime="current.mime"
        :url="fileUrl"
        :application-id="applicationId"
        @close="showFilePreviewModal = false"
      />
      <div class="file-browser-wrapper">
        <div class="file-browser-scroll">
          <a
            v-if="
              !['CURRENT_TENANT', 'SECONDARY_TENANT'].includes(currentModal) &&
              hasScriveDocument &&
              !selectedType
            "
            :href="scriveLink"
            class="folder-name"
          >
            <FolderRow>
              <BaseImage :url="svgs.ICONS.PDF" class="icon"></BaseImage>
              <div class="folder-info">Signerad ansökan</div>
            </FolderRow>
          </a>
          <div v-if="selectedApplicantId !== null">
            <transition-group
              v-for="(file, idx) in documentsByApplicantId"
              :key="idx"
              name="shuffle"
              appear
            >
              <FolderRow
                :key="file.fileName"
                tag="button"
                type="button"
                @click="
                  preview(
                    file.uuid,
                    file.fileName,
                    docTypeUtils.getFileExtension(file.fileName)
                  )
                "
              >
                <BaseImage
                  :url="docTypeUtils.getFileIcon(file.fileName)"
                  class="icon"
                ></BaseImage>
                <div class="folder-info">
                  <div class="folder-name">
                    {{ docTypeUtils.getFilename(file.fileName) }}
                  </div>
                  <div class="file-meta">
                    {{ docTypeUtils.getDocTypeStr(file.type) }} /
                    <span class="file-type">{{
                      docTypeUtils.getFileExtension(file.fileName)
                    }}</span
                    >,
                    {{ docTypeUtils.getHumanFileSize(file.fileSize) }}
                    /
                    <span class="fake-link">Förhandsgranska</span>
                  </div>
                </div>
              </FolderRow>
            </transition-group>
          </div>
          <div
            v-else-if="
              ['CURRENT_TENANT', 'SECONDARY_TENANT'].includes(currentModal)
            "
          >
            <transition-group
              v-for="(file, idx) in getFiles"
              :key="idx"
              name="shuffle"
              appear
            >
              <FolderRow
                :key="file.fileName"
                tag="button"
                type="button"
                @click="
                  preview(
                    file.uuid,
                    file.fileName,
                    docTypeUtils.getFileExtension(file.fileName)
                  )
                "
              >
                <BaseImage
                  :url="docTypeUtils.getFileIcon(file.fileName)"
                  class="icon"
                ></BaseImage>
                <div class="folder-info">
                  <div class="folder-name">
                    {{ docTypeUtils.getFilename(file.fileName) }}
                  </div>
                  <div class="file-meta">
                    {{ docTypeUtils.getDocTypeStr(file.type) }} /
                    <span class="file-type">{{
                      docTypeUtils.getFileExtension(file.fileName)
                    }}</span
                    >,
                    {{ docTypeUtils.getHumanFileSize(file.fileSize) }}
                    /
                    <span class="fake-link">Förhandsgranska</span>
                  </div>
                </div>
              </FolderRow>
            </transition-group>
          </div>
          <template v-else>
            <FolderRow
              tag="button"
              type="button"
              @click.stop.prevent="additionalFilesModalVisible = true"
            >
              <BaseImage :url="svgs.ICONS.FOLDER" class="icon"></BaseImage>
              <div class="folder-info">
                <div class="folder-name">Uppladdade filer</div>
                <div class="file-meta">
                  {{ filesFromId.length }} uppladdade filer /
                  <span class="upload-files">Ladda upp</span>
                </div>
              </div>
            </FolderRow>
            <FolderRow
              tag="button"
              type="button"
              :disabled="!currentTenantFiles?.length"
              @click.stop.prevent="currentModal = 'CURRENT_TENANT'"
            >
              <BaseImage :url="svgs.ICONS.FOLDER" class="icon"></BaseImage>
              <div class="folder-info">
                <div class="folder-name">{{ currentTenantName }}</div>
                <div class="file-meta">
                  {{ currentTenantFiles?.length || 0 }} uppladdade filer
                </div>
              </div>
            </FolderRow>
            <FolderRow
              v-if="!singleDocsMode"
              tag="button"
              type="button"
              :disabled="!secondaryTenantFiles?.length"
              @click.stop.prevent="currentModal = 'SECONDARY_TENANT'"
            >
              <BaseImage :url="svgs.ICONS.FOLDER" class="icon"></BaseImage>
              <div class="folder-info">
                <div class="folder-name">{{ secondaryTenantName }}</div>
                <div class="file-meta">
                  {{ secondaryTenantFiles?.length || 0 }} uppladdade filer
                </div>
              </div>
            </FolderRow>
          </template>
        </div>
      </div>
    </template>

    <template #footer>
      <BaseButton
        v-if="
          !['CURRENT_TENANT', 'SECONDARY_TENANT'].includes(currentModal) &&
          !selectedType
        "
        :is-rounded="true"
        :icon="svgs.ICONS.UPLOAD"
        @click.stop.prevent="additionalFilesModalVisible = true"
      >
        Ladda upp filer
      </BaseButton>

      <div
        v-if="
          !['CURRENT_TENANT', 'SECONDARY_TENANT'].includes(currentModal) &&
          !selectedType
        "
        class="popupModal-container"
      >
        <PopupModal
          v-if="popupModalVisible"
          :items="itemsInPopupModal"
          @close="popupModalVisible = false"
          @click="handlePopupClick"
        />
        <BaseButton
          :is-rounded="true"
          :icon="svgs.ICONS.DOWNLOAD"
          @click="popupModalVisible = !popupModalVisible"
        >
          Ladda ner filer
        </BaseButton>
      </div>

      <a
        v-if="
          ['CURRENT_TENANT', 'SECONDARY_TENANT'].includes(currentModal) &&
          !selectedType
        "
        :href="
          getZipFile(
            currentModal === 'SECONDARY_TENANT'
              ? 'secondary_tenant'
              : 'current_tenant'
          )
        "
      >
        <BaseButton :is-rounded="true" :icon="svgs.ICONS.DOWNLOAD">
          Ladda ner som ZIP
        </BaseButton>
      </a>

      <BaseButton
        v-if="
          ['CURRENT_TENANT', 'SECONDARY_TENANT'].includes(currentModal) &&
          !selectedType
        "
        :is-rounded="true"
        :is-default="true"
        @click.stop.prevent="currentModal = ''"
        >Tillbaka</BaseButton
      >

      <BaseButton
        v-if="!['CURRENT_TENANT', 'SECONDARY_TENANT'].includes(currentModal)"
        :is-rounded="true"
        :is-default="true"
        @click="$emit('close')"
        >Stäng</BaseButton
      >
    </template>
  </DefaultModal>
</template>

<script>
import { apiEndpoint } from '@/services/apiInstance';
import { mapState } from 'vuex';

import docTypeUtils from '@/utils/docs-utils';
import DefaultModal from '@/components/DefaultModal.vue';
import BaseButton from '@/components/BaseButton.vue';
import svgs from '@/utils/icon-constants';
import BaseImage from '@/components/BaseImage.vue';
import DefaultModalTitle from '@/components/DefaultModalTitle.vue';
import GeneratePdfModal from '@/components/GeneratePdfModal.vue';
import AdditionalFilesModal from '@/components/AdditionalFilesModal.vue';
import PopupModal from '@/components/PopupModal.vue';
import FilePreviewModal from '@/components/FilePreviewModal.vue';
import FolderRow from '@/components/FolderRow.vue';

export default {
  name: 'SubletDocumentsModal',
  components: {
    DefaultModal,
    BaseButton,
    BaseImage,
    GeneratePdfModal,
    AdditionalFilesModal,
    PopupModal,
    DefaultModalTitle,
    FilePreviewModal,
    FolderRow
  },

  props: {
    selectedName: {
      type: String,
      default: ''
    },
    currentTenantName: {
      type: String,
      default: ''
    },
    secondaryTenantName: {
      type: String,
      default: ''
    },
    applicationId: {
      type: String,
      default: null
    },

    hasScriveDocument: {
      type: Boolean,
      default: false
    },

    selectedType: {
      type: String,
      default: null
    },
    selectedDocumentCategoryTypes: {
      type: Array,
      default: () => []
    },
    selectedApplicantId: {
      type: String,
      default: null
    },

    files: {
      type: Array,
      default: () => []
    },
    singleDocsMode: {
      type: Boolean,
      required: true
    }
  },
  emits: ['close'],

  data() {
    return {
      svgs,
      docTypeUtils,
      additionalFilesModalVisible: false,
      popupModalVisible: false,
      generatePdfVisible: false,
      itemsInPopupModal: [
        {
          title: 'Ladda ner som ZIP',
          icon: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.29 17.2899L13 18.5899V12.9999C13 12.7347 12.8947 12.4803 12.7071 12.2928C12.5196 12.1053 12.2652 11.9999 12 11.9999C11.7348 11.9999 11.4804 12.1053 11.2929 12.2928C11.1054 12.4803 11 12.7347 11 12.9999V18.5899L9.71001 17.2899C9.61677 17.1967 9.50608 17.1227 9.38426 17.0722C9.26244 17.0218 9.13187 16.9958 9.00001 16.9958C8.86815 16.9958 8.73758 17.0218 8.61576 17.0722C8.49394 17.1227 8.38325 17.1967 8.29001 17.2899C8.19677 17.3831 8.12281 17.4938 8.07235 17.6156C8.02189 17.7375 7.99592 17.868 7.99592 17.9999C7.99592 18.1318 8.02189 18.2623 8.07235 18.3841C8.12281 18.506 8.19677 18.6167 8.29001 18.7099L11.29 21.7099C11.3851 21.8009 11.4973 21.8723 11.62 21.9199C11.7397 21.9728 11.8691 22.0001 12 22.0001C12.1309 22.0001 12.2603 21.9728 12.38 21.9199C12.5028 21.8723 12.6149 21.8009 12.71 21.7099L15.71 18.7099C15.8983 18.5216 16.0041 18.2662 16.0041 17.9999C16.0041 17.7336 15.8983 17.4782 15.71 17.2899C15.5217 17.1016 15.2663 16.9958 15 16.9958C14.7337 16.9958 14.4783 17.1016 14.29 17.2899ZM18.42 6.21989C17.809 4.8159 16.7545 3.65097 15.4181 2.90362C14.0817 2.15627 12.5371 1.86773 11.021 2.0822C9.50489 2.29668 8.10094 3.00235 7.02427 4.09107C5.9476 5.17979 5.2576 6.59151 5.06001 8.10989C4.1066 8.33822 3.27023 8.90873 2.70975 9.71308C2.14927 10.5174 1.9037 11.4996 2.01968 12.4731C2.13566 13.4466 2.60511 14.3436 3.33888 14.9938C4.07265 15.6439 5.01964 16.002 6.00001 15.9999C6.26523 15.9999 6.51958 15.8945 6.70712 15.707C6.89466 15.5195 7.00001 15.2651 7.00001 14.9999C7.00001 14.7347 6.89466 14.4803 6.70712 14.2928C6.51958 14.1053 6.26523 13.9999 6.00001 13.9999C5.46958 13.9999 4.96087 13.7892 4.5858 13.4141C4.21073 13.039 4.00001 12.5303 4.00001 11.9999C4.00001 11.4695 4.21073 10.9608 4.5858 10.5857C4.96087 10.2106 5.46958 9.99989 6.00001 9.99989C6.26523 9.99989 6.51958 9.89454 6.70712 9.707C6.89466 9.51946 7.00001 9.26511 7.00001 8.99989C7.00257 7.81717 7.4243 6.67365 8.19028 5.77248C8.95627 4.87131 10.0169 4.27085 11.1838 4.07777C12.3506 3.88469 13.5481 4.1115 14.5636 4.7179C15.579 5.32431 16.3466 6.27103 16.73 7.38989C16.7872 7.56173 16.8899 7.71483 17.0273 7.83283C17.1647 7.95083 17.3315 8.02931 17.51 8.0599C18.1761 8.18577 18.7799 8.5335 19.223 9.04643C19.6662 9.55936 19.9226 10.2073 19.9504 10.8845C19.9782 11.5618 19.7759 12.2286 19.3763 12.7761C18.9767 13.3237 18.4035 13.7198 17.75 13.8999C17.6226 13.9327 17.503 13.9903 17.3978 14.0694C17.2927 14.1485 17.2042 14.2475 17.1373 14.3608C17.0705 14.4741 17.0266 14.5994 17.0082 14.7297C16.9898 14.8599 16.9972 14.9925 17.03 15.1199C17.0628 15.2473 17.1204 15.3669 17.1995 15.4721C17.2786 15.5772 17.3776 15.6657 17.4909 15.7326C17.6042 15.7994 17.7295 15.8433 17.8598 15.8617C17.99 15.8801 18.1226 15.8727 18.25 15.8399C19.3024 15.5618 20.2353 14.9479 20.907 14.0914C21.5787 13.2348 21.9526 12.1825 21.9718 11.0942C21.9911 10.0058 21.6546 8.94094 21.0136 8.06121C20.3725 7.18149 19.4619 6.53499 18.42 6.21989Z" fill="#878B9D"/>
          </svg>
          `,
          content: '',
          cta: 'Klicka här för att ladda ner alla filer',
          type: 'DOWNLOAD_ZIP'
        },
        {
          title: 'Generera PDF',
          icon: `<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM6.5 8.5C6.5 9.3 5.8 10 5 10H4V12H2.5V6H5C5.8 6 6.5 6.7 6.5 7.5V8.5ZM11.5 10.5C11.5 11.3 10.8 12 10 12H7.5V6H10C10.8 6 11.5 6.7 11.5 7.5V10.5ZM15.5 7.5H14V8.5H15.5V10H14V12H12.5V6H15.5V7.5ZM9 7.5H10V10.5H9V7.5ZM4 7.5H5V8.5H4V7.5Z" fill="#878B9D"/>
            </svg>`,
          content: '',
          cta: 'Klicka här för att generera PDF',
          type: 'GENERATE_PDF'
        }
      ],
      currentModal: '',
      showFilePreviewModal: false,
      current: { id: '', title: '', mime: '' }
    };
  },

  computed: {
    ...mapState({
      landlordFiles: state => state.landlordFiles.files
    }),
    filesFromId() {
      return this.landlordFiles[this.applicationId] || [];
    },
    scriveLink() {
      return `${apiEndpoint}/andrahand/portal/documents/scrive/${this.applicationId}`;
    },
    fileUrl() {
      return `${apiEndpoint}/andrahand/portal/documents/${this.applicationId}/${this.current.id}`;
    },
    documentsByApplicantId() {
      return (
        this.files.filter(
          file =>
            !this.selectedType ||
            (this.selectedType === file.type &&
              this.selectedDocumentCategoryTypes.includes(file.categoryType))
        ) || []
      );
    },
    documentsCollections() {
      const docs = Array.isArray(this.documentsByApplicantId)
        ? this.documentsByApplicantId
        : [];

      const mapDoc = d => ({
        fileName: d.fileName,
        fileSize: d.fileSize,
        folder: d.folder,
        type: d.type,
        id: d.uuid
      });

      const currentTenantDocs = docs.filter(
        d => d.categoryType === 'current_tenant' || d.categoryType == null
      );
      const secondaryTenantDocs = docs.filter(
        d => d.categoryType === 'secondary_tenant'
      );

      return {
        ...(currentTenantDocs.length && this.currentTenantName
          ? { [this.currentTenantName]: currentTenantDocs.map(mapDoc) }
          : {}),
        ...(secondaryTenantDocs.length && this.secondaryTenantName
          ? { [this.secondaryTenantName]: secondaryTenantDocs.map(mapDoc) }
          : {})
      };
    },
    currentTenantFiles() {
      return this.files.filter(
        file =>
          file.categoryType === 'current_tenant' || file.categoryType === null
      );
    },
    secondaryTenantFiles() {
      return this.files.filter(
        file => file.categoryType === 'secondary_tenant'
      );
    },
    getFiles() {
      if (this.currentModal === 'CURRENT_TENANT') {
        return this.currentTenantFiles;
      }
      if (this.currentModal === 'SECONDARY_TENANT') {
        return this.secondaryTenantFiles;
      }
      return [];
    },
    currentModalName() {
      if (this.currentModal === 'CURRENT_TENANT') {
        return this.currentTenantName;
      }
      if (this.currentModal === 'SECONDARY_TENANT') {
        return this.secondaryTenantName;
      }
      return '';
    }
  },

  methods: {
    preview(id, title, mime) {
      this.current = { id, title, mime: mime || '' };
      this.showFilePreviewModal = true;
    },
    getZipFile(categoryType) {
      if (!categoryType) {
        return `${apiEndpoint}/andrahand/portal/documents/zip/${this.applicationId}`;
      }

      return `${apiEndpoint}/andrahand/portal/documents/zip/${this.applicationId}/${categoryType}`;
    },
    handlePopupClick(type) {
      switch (type) {
        case 'DOWNLOAD_ZIP':
          if (this.currentModal === '') {
            const zipFileUrl = this.getZipFile();
            const anchor = document.createElement('a');
            anchor.style.display = 'none';
            anchor.href = zipFileUrl;
            anchor.download = 'file.zip';
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
          }

          break;
        case 'GENERATE_PDF':
          this.generatePdfVisible = true;
          break;
        default:
      }

      this.popupModalVisible = false;
    }
  }
};
</script>

<style scoped>
.file-browser-wrapper {
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  overflow: hidden;
}
.file-browser-scroll {
  max-height: 50vh;
  overflow-y: auto;
}
.icon {
  display: inline-flex;
  height: 36px;
  width: 45px;
  margin-right: 12px;
}

.folder-info {
  display: inline-block;
  vertical-align: top;
  font-weight: 600;
}
.folder-name {
  display: block;
  color: var(--color-dark-blue);
  font-size: 1.8rem;
  font-weight: 600;
}
.file-meta {
  display: block;
  font-size: 1.4rem;
  color: #878b9d;
  font-weight: 600;
  line-height: 17px;
}
.file-meta .upload-files {
  color: var(--color-blue);
  text-decoration: underline;
  font-weight: 600;
}
.file-meta .file-type {
  text-transform: capitalize;
}
.file-meta .fake-link {
  color: var(--color-blue);
  text-decoration: underline;
}
.popupModal-container {
  position: relative;
  vertical-align: text-bottom;
  display: inline-block;
}
</style>
